module.exports = "/_next/static/images/OgChannel-b3cebbad05879e5fbcfff145d0d6f7b1.png";